import { render, staticRenderFns } from "./material-switch.vue?vue&type=template&id=06da4ab8&"
import script from "./material-switch.vue?vue&type=script&lang=js&"
export * from "./material-switch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports